<template>
  <div>
    <v-sheet>

      <v-btn class="mx-3 my-2" color="secondary" dense small style="text-transform: none" @click="clearfilters">Clear
        All Filters
      </v-btn>
      <v-btn class="mx-3 my-2" color="primary" dense small style="text-transform: none" @click="downloadCSV">
        Download TSV
        <v-icon>mdi-download-box-outline</v-icon>
      </v-btn>
      <v-sheet outlined>
        <v-data-table
            :footer-props="{ 'items-per-page-options': [10, 20, 50, 100],
                          'show-current-page': true,'show-all-page':true}"
            :headers="tableheader"
            :items="filteredItems"
            :items-per-page="10"
            dense
            fixed-header
            height="400px"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            no-data-text="No results available. Please try other site."
            no-results-text="No results found for the current search terms. Please try different keywords."
            style="table-layout: fixed; width: 100%;"

        >
          <template
              v-for="header in tableheader"
              v-slot:[`header.${header.value}`]="{ header }"
          >
            <div class="d-flex align-center">

            <span
                class="d-flex align-center"
                v-on="header.on"
                style="cursor:pointer"
            >
              {{ header.text }}

              <v-icon
                  v-if="sortBy.includes(header.value)"
                  small
                  class="ml-1"
              >
                {{ sortDesc[sortBy.indexOf(header.value)]
                  ? 'mdi-arrow-down'
                  : 'mdi-arrow-up' }}
              </v-icon>
            </span>
            </div>


              <!-- categorical filter -->
            <template v-if="filters.hasOwnProperty(header.value)">
              <v-menu
                  :close-on-content-click="false"
                  offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                  >
                    <v-icon
                        :color="filters[header.value].length ? 'red' : ''"
                        small
                    >
                      mdi-filter-variant
                    </v-icon>
                  </v-btn>
                </template>

                <div style="background-color: white; width: 280px">
                  <v-list>
                    <v-list-item>
                      <v-autocomplete
                          v-model="filters[header.value]"
                          :items="columnValueList(header.value)"
                          :label="filters[header.value].length
                ? `Filter by ${header.text}`
                : `Choose ${header.text}`"
                          chips
                          clearable
                          dense
                          hide-details
                          multiple
                          small-chips
                      />
                    </v-list-item>
                  </v-list>
                </div>
              </v-menu>
            </template>

            <!-- numeric filter -->
            <template v-else-if="numericFilters.hasOwnProperty(header.value)">
              <v-menu
                  :close-on-content-click="false"
                  offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                  >
                    <v-icon
                        :color="numericFilters[header.value].min ||
                    numericFilters[header.value].max
                    ? 'red'
                    : ''"
                        small
                    >
                      mdi-filter
                    </v-icon>
                  </v-btn>
                </template>

                <div style="background-color: white; width: 280px">
                  <v-row no-gutters class="pa-2">
                    <v-col cols="5">
                      <v-text-field
                          v-model="numericFilters[header.value].min"
                          clearable
                          dense
                          label="Min"
                          outlined
                          type="number"
                      />
                    </v-col>

                    <v-col cols="2" class="text-center">-</v-col>

                    <v-col cols="5">
                      <v-text-field
                          v-model="numericFilters[header.value].max"
                          clearable
                          dense
                          label="Max"
                          outlined
                          type="number"
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-menu>
            </template>
          </template>
        </v-data-table>
      </v-sheet>
    </v-sheet>
  </div>
</template>


<script>
import phenotype from "@/components/Phenotype.vue";

export default {
  name: "PhenotypeTable",
  props: ["filteredData"],
  components: {},
  data() {
    return {
      sortBy: [],
      sortDesc: [],
      filters: {
        phenotype: [],
        pheno_category: [],
        cancer_type: [],
        pheno_ptm_sig: [],
        pheno_ptm_rna_sig: [],
        pheno_ptm_protein_sig: []

      },
      numericFilters: {
        pheno_ptm_pvalue: {min: null, max: null},
        pheno_rna_pvalue: {min: null, max: null},
        pheno_protein_pvalue: {min: null, max: null},
        ptm_tn_pvalue: {min: null, max: null},
        pheno_ptm_val: {min: null, max: null},
        pheno_rna_val: {min: null, max: null},
        pheno_protein_val: {min: null, max: null},
      },
      tableheader: [
        {text: 'Dataset name', value: 'dataset_name', align: 'start', sortable: true, width: "22%"},
        {text: 'Phenotype', value: 'phenotype', align: 'start', sortable: true, width: "10%"},
        {text: 'Pheno-category', value: 'pheno_category', align: 'start', sortable: true, width: "6%"},
        {text: 'Cancer type', value: 'cancer_type', align: 'start', sortable: true, width: "6%"},
        {text: 'PTM-pheno pval', value: 'pheno_ptm_pvalue_display', align: 'start', sortable: true, width: "6%"},
        {text: 'PTM-pheno val', value: 'pheno_ptm_val', align: 'start', sortable: true, width: "6%"},
        {text: 'RNA-pheno pval', value: 'pheno_rna_pvalue_display', align: 'start', sortable: true, width: "6%"},
        {text: 'RNA-pheno val', value: 'pheno_rna_val', align: 'start', sortable: true, width: "6%",},
        {text: 'Protein-pheno pval', value: 'pheno_protein_pvalue_display', align: 'start', sortable: true, width: "6%"},
        {text: 'Protein-pheno val', value: 'pheno_protein_val', align: 'start', sortable: true, width: "6%"},
        // {text: 'Site abundance(pval)', value: 'ptm_tn_pvalue', align: 'start', sortable: true},
        {text: 'PTM-pheno Significance', value: 'pheno_ptm_sig', align: 'start', sortable: true, width: "6%"},
        {text: 'PTM-pheno vs RNA-pheno Significance', value: 'pheno_ptm_rna_sig', align: 'start', sortable: true, width: "6%"},
        {text: 'PTM-pheno vs Protein-pheno Significance', value: 'pheno_ptm_protein_sig', align: 'start', sortable: true, width: "8%"},
      ],
    }
  },
  computed: {
    processedData() {
      return this.filteredData.map((item) => {

        const ptmNorm = Number(item.pheno_ptm_normpval)
        const rnaNorm = Number(item.pheno_rna_normpval)
        const proteinNorm = Number(item.pheno_protein_normpval)

        const pheno_ptm_sig = Math.abs(ptmNorm) > 3 ? 'Significant' : 'NS'
        const pheno_ptm_rna_sig =
            this.isSignificant(ptmNorm, rnaNorm) ? 'Significant' : 'NS'
        const pheno_ptm_protein_sig =
            this.isSignificant(ptmNorm, proteinNorm) ? 'Significant' : 'NS'

        return {
          ...item,
          // pheno_ptm_pvalue: Math.abs(Number(item.pheno_ptm_pvalue)),
          // pheno_rna_pvalue: Math.abs(Number(item.pheno_rna_pvalue)),
          // pheno_protein_pvalue: Math.abs(Number(item.pheno_protein_pvalue)),
          pheno_ptm_pvalue:Number(item.pheno_ptm_pvalue),
          pheno_rna_pvalue: Number(item.pheno_rna_pvalue),
          pheno_protein_pvalue: Number(item.pheno_protein_pvalue),
          pheno_ptm_pvalue_display: this.formatPvalue(item.pheno_ptm_pvalue),
          pheno_rna_pvalue_display: this.formatPvalue(item.pheno_rna_pvalue),
          pheno_protein_pvalue_display: this.formatPvalue(item.pheno_protein_pvalue),

          pheno_ptm_val: Number(item.pheno_ptm_val),
          pheno_rna_val: Number(item.pheno_rna_val),
          pheno_protein_val: Number(item.pheno_protein_val),

          pheno_ptm_sig,
          pheno_ptm_rna_sig,
          pheno_ptm_protein_sig
        }
      })
    },

    filteredItems() {
      // Use processedData instead of filteredData to access precomputed values
      if (
          !Object.keys(this.filters).some((f) => this.filters[f].length) &&
          !Object.keys(this.numericFilters).some(
              (f) => this.numericFilters[f].min !== null || this.numericFilters[f].max !== null
          )
      ) {
        return this.processedData; // Return unfiltered data if no filters are applied
      }

      // Initialize an array to store filter functions
      let filterFunctions = [];

      // Prepare categorical filters
      Object.keys(this.filters).forEach((f) => {
        if (this.filters[f].length > 0) {
          filterFunctions.push((item) => this.filters[f].includes(item[f]));
        }
      });

      // Prepare numeric filters
      Object.keys(this.numericFilters).forEach((f) => {
        const filter = this.numericFilters[f];
        if (filter.min !== null && filter.max !== null) {
          filterFunctions.push(item => {
            const val = Number(item[f])
            return !isNaN(val) && val >= filter.min && val <= filter.max
          })
        } else if (filter.min !== null) {
          filterFunctions.push(item => {
            const val = Number(item[f])
            return !isNaN(val) && val >= filter.min
          })
        } else if (filter.max !== null) {
          filterFunctions.push(item => {
            const val = Number(item[f])
            return !isNaN(val) && val <= filter.max
          })
        }

        // if (filter.min !== null && filter.max !== null) {
        //   filterFunctions.push((item) => {
        //     const val = parseFloat(item[f]);
        //     return val >= filter.min && val <= filter.max;
        //   });
        // } else if (filter.min !== null) {
        //   filterFunctions.push((item) => {
        //     const val = parseFloat(item[f]);
        //     const max = Math.max(parseFloat(item[f]))
        //     return val >= filter.min && val <= max;
        //   })
        //   // filterFunctions.push((item) => parseFloat(item[f]) >= filter.min);
        // } else if (filter.max !== null) {
        //   filterFunctions.push((item) => {
        //     console.log(filter.max)
        //     const val = parseFloat(item[f]);
        //     const min = Math.min(parseFloat(item[f]))
        //     return val >= min && val <= filter.max;
        //   })
        //   // filterFunctions.push((item) => parseFloat(item[f]) <= filter.max);
        // }
      });

      // Apply all filters at once
      return this.processedData.filter(item =>
          filterFunctions.every(func => func(item))
      );
    }


  },
  methods: {
    isSignificant(value1, value2) {
      const absValue1 = Math.abs(value1);
      const absValue2 = Math.abs(value2);

      if ((value1 > 0 && value2 > 0) || (value1 < 0 && value2 < 0)) {
        if ((absValue1 - absValue2) > 1 && absValue1 > 3) {
          return true;
        }
      } else if ((value1 > 0 && value2 < 0) || (value1 < 0 && value2 > 0)) {
        if (absValue1 > 3) {
          return true;
        }
      }
      return false;
    },
    columnValueList(val) {
      return [...new Set(this.processedData.map(d => d[val]))];
    },
    formatPvalue(value) {
      const num = Number(value);

      if (value === null || value === undefined || value === '' || isNaN(num)) {
        return '-';
      }

      if (num === 0) {
        return '0';
      }

      if (Math.abs(num) < 0.001) {
        return num.toExponential(2);
      }

      return num.toFixed(4).replace(/\.?0+$/, '');
    },

    clearNumericFilter(col) {
      this.numericFilters[col].min = null;
      this.numericFilters[col].max = null;
    },
    clearfilters() {
      this.filters = {
        phenotype: [],
        pheno_category: [],
        cancer_type: [],
        pheno_ptm_sig: [],
        pheno_ptm_rna_sig: [],
        pheno_ptm_protein_sig: []
      }

      this.numericFilters = {
        pheno_ptm_pvalue: {min: null, max: null},
        pheno_rna_pvalue: {min: null, max: null},
        pheno_protein_pvalue: {min: null, max: null},
        ptm_tn_pvalue: {min: null, max: null},
        pheno_ptm_val: {min: null, max: null},
        pheno_rna_val: {min: null, max: null},
        pheno_protein_val: {min: null, max: null},
      }
    },
    downloadCSV() {
      const csvContent = this.convertToCSV(this.filteredItems);
      const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'});
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', 'ptmatlas_site_phenotype.tsv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    // Method to convert data to CSV format
    convertToCSV(data) {
      const headers = this.tableheader.map(header => header.text).join('\t') + '\n';
      const rows = data.map(item => {
        return this.tableheader.map(header => item[header.value]).join('\t');
      }).join('\n');
      return headers + rows;
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped type="text/scss">
</style>